import { useEffect, useState } from "react";
import { Alert, AlertDescription, AlertTitle } from "../ui/alert";
import { Button } from "../ui/button";
import Link from "next/link";
import { get } from "@/api/dashboard-auth.client";
import { useTranslations } from "next-intl";

export default function EventContainerManageCard({ event }: any) {
  const t = useTranslations("EventEditorContainer");

  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    event &&
      event.id &&
      get("/event/{id}", {
        params: {
          path: {
            id: event.id,
          },
        },
      }).then((fetchResponse: any) => {
        if (fetchResponse.error) {
          setCanManage(false);
        } else {
          setCanManage(true);
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (canManage)
    return (
      <Alert className="flex flex-col gap-1 p-2 border-0 rounded-xl bg-secondary/40 backdrop-blur">
        <AlertTitle>{t("this-is-your-event-you-can-manage-it")}</AlertTitle>
        <AlertDescription className="flex flex-row gap-2 md:flex-col justify-evenly">
          <Button
            className="relative z-10 w-full mt-2 border bg-secondary/50 border-primary/5"
            variant={"secondary"}
            size={"sm"}
            asChild
          >
            <Link
              href={
                process.env.BASE_UI_URL +
                "/events/" +
                event.id +
                "/edit?editor=true"
              }
            >
              {t("manage")}
            </Link>
          </Button>
        </AlertDescription>
      </Alert>
    );
}
